"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.generateMessageTaskId = exports.generateUuid = void 0;
var generateUuid = function (userId, feed) {
    if (feed) {
        return userId + feed.slice(0, 5);
    }
    return userId;
};
exports.generateUuid = generateUuid;
/**
 * 生成消息taskid
 *
 * @returns
 */
var generateMessageTaskId = function () {
    // 换成64位
    var randRange = 18446744073709551;
    var seq = Math.ceil(Math.random() * randRange);
    return seq;
};
exports.generateMessageTaskId = generateMessageTaskId;
